/* eslint-disable react/prop-types */
import React from 'react';
import { InputSuffix as OriginalInputSuffix } from '@fiverr-private/forms';
import { useParentPropsOverrideContext } from '@fiverr-private/ui_utils';

const InputSuffix = ({ children, ...props }) => {
    const context = useParentPropsOverrideContext();

    return (
        <OriginalInputSuffix {...props} {...context}>
            {children}
        </OriginalInputSuffix>
    );
};

export default InputSuffix;
